export const plural = (n, word) => `${n} ${word}${n === 1 ? '' : /(s|x|z|ch|sh)$/.test(word) ? 'es' : 's'}`

export const DEFAULT_EXCLUSION_NOTE = 500

const KB = 1024
export function formatSize(bytes) {
  if (!bytes) return '—'
  if (bytes < KB) return `${bytes} B`
  if (bytes < KB * KB) return `${Math.round(bytes / KB)} KB`
  return `${(bytes / KB / KB).toFixed(1)} MB`
}

export const join = (...parts) => parts.filter(Boolean).join(' · ')
export const sizeOf = bytes => (bytes ? formatSize(bytes) : '')

const PLAIN_DAY = /^\d{4}-\d{2}-\d{2}$/
export function serverDay(value) {
  if (!value) return null
  if (typeof value === 'string' && PLAIN_DAY.test(value)) return value
  const at = value instanceof Date ? value : new Date(value)
  return Number.isNaN(at.getTime()) ? null : at.toISOString().slice(0, 10)
}
export function formatDay(value) {
  const day = serverDay(value)
  if (!day) return '—'
  const [y, m, d] = day.split('-').map(Number)
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
}

export function whenLabel(iso, now = new Date()) {
  const d = new Date(iso)
  if (d.toDateString() === now.toDateString()) return `today ${d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`
  return formatDay(d)
}

export const TIER_LABEL = { filename: 'filename', document: 'document', metadata: 'metadata', earliest: 'earliest source' }
